/**
 * Validator for `path_PathUpdateResource`.
 * Required: active, autoOptimized, listicle, name, offerRedirectMode, offers,
 * realtimeRoutingApiState, weight.
 *
 * Voluum's automation fields (`autoOptimizationMode`, `calculationMethod`) are
 * conditional on `autoOptimized` — see `path-fields.ts`.
 *
 * For Media Devoted | Created By Ciro Autiero
 */

import {
  OFFER_REDIRECT_MODE_VALUES,
  PATH_REALTIME_ROUTING_VALUES,
} from '../enums';
import {
  isPlainObject,
  joinPath,
  pushError,
  requireBoolean,
  requireNumber,
  requireString,
  type ValidationCtx,
} from '../primitives';
import { validateAutomationFields, validatePathOptional } from './path-fields';
import { validateRefList } from './ref-list';

function validatePathRequired(
  ctx: ValidationCtx,
  raw: Record<string, unknown>,
  basePath: string,
): void {
  requireBoolean(ctx, raw, 'active', basePath);
  requireBoolean(ctx, raw, 'autoOptimized', basePath);
  requireBoolean(ctx, raw, 'listicle', basePath);
  requireString(ctx, raw, 'name', basePath);
  requireString(
    ctx,
    raw,
    'offerRedirectMode',
    basePath,
    OFFER_REDIRECT_MODE_VALUES,
  );
  requireString(
    ctx,
    raw,
    'realtimeRoutingApiState',
    basePath,
    PATH_REALTIME_ROUTING_VALUES,
  );
  requireNumber(ctx, raw, 'weight', basePath);
}

export function validatePathUpdate(
  ctx: ValidationCtx,
  v: unknown,
  basePath: string,
): void {
  if (!isPlainObject(v)) {
    pushError(ctx, basePath, 'invalid_object', 'Expected path object');
    return;
  }
  validatePathRequired(ctx, v, basePath);
  validateAutomationFields(ctx, v, basePath);
  validatePathOptional(ctx, v, basePath);

  if (v.offers === undefined) {
    pushError(
      ctx,
      joinPath(basePath, 'offers'),
      'missing_required',
      'Missing required field "offers"',
    );
  } else {
    validateRefList(ctx, v.offers, joinPath(basePath, 'offers'), 'offer');
  }
  if (v.landers !== undefined) {
    validateRefList(ctx, v.landers, joinPath(basePath, 'landers'), 'lander');
  }
}
